export const PaymentMethods = [
    "cash",
    "card",
    "stripe",
    "poli",
    "bambora",
];
//# sourceMappingURL=payment-methods.js.map